import { t } from '@lingui/macro';

export const LICENSE_TYPE_PERMANENT = t`Permanent`;
export const LICENSE_TYPE_EVALUATION = t`Evaluation`;
export const LICENSE_TYPE_EXPIRED = t`Evaluation Expired`;
export const LICENSE_TYPE_NONE = t`None`;

export const LICENSE_SERVER_HEADER_TEXT = t`nGeniusPULSE Server`;
export const LICENSE_COLLECTOR_HEADER_TEXT = t`nGeniusPULSE Collector`;
export const LICENSE_AGENT_2K_HEADER_TEXT = t`nPoint 2000 Licenses`;
export const LICENSE_AGENT_3K_HEADER_TEXT = t`nPoint 3000 Licenses`;

export const LICENSE_SERVER_OBJECT = 'server';
export const LICENSE_COLLECTOR_OBJECT = 'collector';
export const LICENSE_2K_OBJECT = 'agents2k';
export const LICENSE_3K_OBJECT = 'agents3k';
export const LICENSE_290_OBJECT = 'agents290';
export const LICENSE_490_OBJECT = 'agents490';
export const LICENSE_795_OBJECT = 'agents795';
export const LICENSE_SEM_OBJECT = 'sem';

export const LICENSE_TYPE_FIELD = 'licenseType';
export const LICENSED_FIELD = 'licensed';
export const SHOW_FAKE_COLLECTOR_FIELD = 'showFakeCollector';
export const SHOW_MONITORED_ELEMENTS_FIELD = 'showMonitoredElements';
export const COUNTS_FORMATTED_FIELD = 'countsFormatted';
export const EVALUATION_LICENSE_FIELD = 'evaluation';
export const FORMATTED_EXPIRATION_DATE_FIELD = 'expirationDateFormatted';
export const IS_OVER_LIMIT_FIELD = 'isOverLimit';
export const LICENSE_DISABLED_COUNT_FORMAT_FIELD = 'licenseDisabledCountFormat';
export const AGENT_2K_USING_3K_FIELD = 'numberOf2ksUsing3kLicenseMsg';
export const AGENT_3K_USING_3K_FIELD = 'numberOf3ksUsing3kLicenseMsg';
export const SINGLE_SEM_FIELD = 'singleSEM';
export const LICENSE_CURRENT_COUNT_FIELD = 'currentCount';
export const LICENSE_TOTAL_COUNT_FIELD = 'count';

export const EXPIRED_TEXT = t`Expired`;
